import { render, staticRenderFns } from "./StudentDataTable.vue?vue&type=template&id=6b9d7fde&scoped=true"
import script from "./StudentDataTable.vue?vue&type=script&lang=js"
export * from "./StudentDataTable.vue?vue&type=script&lang=js"
import style0 from "./StudentDataTable.vue?vue&type=style&index=0&id=6b9d7fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9d7fde",
  null
  
)

export default component.exports